class ImageLinkCarousel extends HTMLElement {
  constructor() {
    super();

    this.list = this.querySelector('[data-image-link-carousel-list]');
    this.previousButton = this.querySelector('[data-image-link-carousel-previous]');
    this.nextButton = this.querySelector('[data-image-link-carousel-next]');
    this.updateArrows = this.updateArrows.bind(this);

    if (!this.list) {
      return;
    }

    initCarouselScroll(this.list, {
      draggingClass: 'image-link-carousel__list--dragging',
      onScroll: this.updateArrows,
    });

    if (this.previousButton) {
      this.previousButton.addEventListener('click', this.onArrowClick.bind(this, 'previous'));
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onArrowClick.bind(this, 'next'));
    }

    window.addEventListener('resize', this.updateArrows);
    this.updateArrows();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updateArrows);
  }

  onArrowClick(direction) {
    const item = this.list.querySelector('.image-link-carousel__item');
    const gap = parseFloat(window.getComputedStyle(this.list).columnGap) || 0;
    const scrollAmount = item ? item.getBoundingClientRect().width + gap : this.list.clientWidth;

    this.list.scrollBy({
      left: direction === 'next' ? scrollAmount : -scrollAmount,
      behavior: 'smooth',
    });

    window.setTimeout(this.updateArrows, 350);
  }

  updateArrows() {
    if (!this.previousButton || !this.nextButton) {
      return;
    }

    const maxScroll = this.list.scrollWidth - this.list.clientWidth;
    const isScrollable = maxScroll > 1;
    const slider = this.list.closest('.image-link-carousel__slider');

    if (slider) {
      slider.classList.toggle('image-link-carousel__slider--arrows-visible', isScrollable);
    }
    this.previousButton.hidden = !isScrollable;
    this.nextButton.hidden = !isScrollable;
    this.previousButton.disabled = this.list.scrollLeft <= 1;
    this.nextButton.disabled = this.list.scrollLeft >= maxScroll - 1;
  }
}

if (!customElements.get('image-link-carousel')) {
  customElements.define('image-link-carousel', ImageLinkCarousel);
}
